import type { ReactNode } from 'react';
import React from 'react';

import cx from '@travel/icons/_utils/classnames';

import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textArea.module.scss';

/** Custom props */
export type TextAreaLabelProps = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
};

export function Label(props: TextAreaLabelProps) {
  const { children, className } = props;

  const classNames = cx(styles[toCamelCase('textArea', 'label')], className);

  return (
    <span className={classNames} data-testid="textArea-label">
      {children}
    </span>
  );
}

export default Label;
